<div class="css-Enlace_Back-1 enlace_back">
    <div class="css-Enlace_icono_izquierda_chico-1 enlace_icono_izquierda_chico">
        <a class="css-a_Enlace_icono_izquierda_chico-1 a_enlace_icono_izquierda_chico">
            <div class="css-Icono_Flecha_Izda_Chico-2 icono_flecha_izda_chico">
                <img src="assets/images/basecomponents-images/enlace-back.svg" width="10.800048828125px"
                    height="10.799987792969px" class="css-arrow_back-1 arrowback">
            </div>
            <p class="css-Texto_enlace-2 texto_enlace">{{enlace_texto}}</p>
        </a>
    </div>
</div>